(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[34],{

/***/ "C5yf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ SiteLayout; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ MenuLayout["b" /* default */]; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ layout_PageLayout; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ layout_CommonLayout; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ layout_AppLayout; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./src/model/user.ts
var model_user = __webpack_require__("44E3");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__("T1Xd");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js + 2 modules
var dropdown = __webpack_require__("jsC+");

// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 10 modules
var menu = __webpack_require__("BvKs");

// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 8 modules
var modal = __webpack_require__("kLXV");

// EXTERNAL MODULE: ./src/services/user-auth.ts
var user_auth = __webpack_require__("HQKk");

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__("8Skl");

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__("cr+I");
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__("+WQr");

// EXTERNAL MODULE: ./src/components/common/index.ts + 13 modules
var components_common = __webpack_require__("K8zp");

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__("1ZD8");

// EXTERNAL MODULE: ./src/services/api.ts
var api = __webpack_require__("Dp36");

// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__("4ISH");

// CONCATENATED MODULE: ./src/components/common/Header.tsx






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var Container = styled_components_browser_esm["d" /* default */].header.withConfig({
  displayName: "Header__Container",
  componentId: "sc-4d0iq1-0"
})(["width:100%;height:", ";background-color:#fefeff;box-shadow:0px 2px 4px 0px rgba(0,10,71,0.04);position:fixed;top:0;left:0;display:flex;align-items:center;justify-content:space-between;z-index:999;"], function (_ref) {
  var theme = _ref.theme;
  return theme.headerHeight;
});
var Nickname = Object(styled_components_browser_esm["d" /* default */])(common["h" /* Ellipsis */]).withConfig({
  displayName: "Header__Nickname",
  componentId: "sc-4d0iq1-1"
})(["font-size:12px;color:#333333;"]);
var ShopName = Object(styled_components_browser_esm["d" /* default */])(common["h" /* Ellipsis */]).withConfig({
  displayName: "Header__ShopName",
  componentId: "sc-4d0iq1-2"
})(["font-size:16px;color:#333333;"]);
var ResourceOwner = Object(styled_components_browser_esm["d" /* default */])(common["h" /* Ellipsis */]).withConfig({
  displayName: "Header__ResourceOwner",
  componentId: "sc-4d0iq1-3"
})(["font-size:12px;font-family:Microsoft YaHei;font-weight:400;color:#999999;margin-top:3px;text-align:left;"]);
var ShopChangeItem = Object(styled_components_browser_esm["d" /* default */])(common["k" /* Row */]).withConfig({
  displayName: "Header__ShopChangeItem",
  componentId: "sc-4d0iq1-4"
})(["cursor:pointer;text-align:right;"]);
var VLine = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Header__VLine",
  componentId: "sc-4d0iq1-5"
})(["width:1px;height:20px;background-color:#ebedf5;margin:0 16px;"]);
function Header() {
  var _user$roles;

  var _useRecoilState = Object(recoil["useRecoilState"])(model_user["e" /* userState */]),
      _useRecoilState2 = Object(slicedToArray["default"])(_useRecoilState, 1),
      user = _useRecoilState2[0];

  var _useRecoilState3 = Object(recoil["useRecoilState"])(model_user["b" /* currentShopState */]),
      _useRecoilState4 = Object(slicedToArray["default"])(_useRecoilState3, 2),
      currentShop = _useRecoilState4[0],
      setCurrentShop = _useRecoilState4[1];

  var _useCurrentShop = Object(hooks["a" /* useCurrentShop */])(),
      _useCurrentShop2 = Object(slicedToArray["default"])(_useCurrentShop, 2),
      getLocalCurrentShop = _useCurrentShop2[0],
      setLocalCurrentShop = _useCurrentShop2[1];

  var _useState = Object(react["useState"])(false),
      shopDropdownVisible = _useState[0],
      setShopDropdownVisible = _useState[1];

  var router = Object(next_router["useRouter"])();
  var isNormal = (user === null || user === void 0 ? void 0 : user.versionType) === 'normal';
  var isInternal = (user === null || user === void 0 ? void 0 : user.versionType) === 'internal';
  var versionMap = new Map([['normal', '基础版'], ['internal', '内部版'], ['enterprise', '企业版']]);
  console.log(currentShop, 'currentShopcurrentShop');

  function handleLogout() {
    user_auth["c" /* logout */]().then(function () {
      router.push('/user/login'); // 退出登录成功，通知插件

      window.postMessage({
        type: 'FROM_PAGE',
        text: user_auth["a" /* getToken */]()
      }, '*');
    });
  } // 如果地址栏没有店铺id，本地也没有 shopInfo，请求店铺列表，将第一个店铺作为默认店铺


  var _useQuery = Object(es["useQuery"])(['getFirstShopList'], function () {
    return Object(api["Dc" /* getShopList */])(1, '');
  }, {
    enabled: false,
    onSuccess: function onSuccess(res) {
      if (res.code === 10000) {
        var firstShop = res.data.records[0];
        setCurrentShop(firstShop);
        setLocalCurrentShop(firstShop);
      }
    }
  }),
      refetch = _useQuery.refetch;

  var _useMutation = Object(es["useMutation"])(api["Cc" /* getShopDetailById */], {
    onSuccess: function onSuccess(res) {
      if (res.code === 10000) {
        setCurrentShop(res.data);
      }
    }
  }),
      getShopDetail = _useMutation.mutate; // 设置店铺信息


  Object(react["useEffect"])(function () {
    var locationParams = query_string_default.a.parse(location.search);
    console.log(locationParams);
    var cachedShop = getLocalCurrentShop(); // alert(locationParams.shopId);

    if (locationParams.shopId) {
      // 查询店铺详情
      getShopDetail(Number(locationParams.shopId));
    } else if (cachedShop) {
      // 本地有该账户缓存的选中店铺
      setCurrentShop(cachedShop);
    } else {
      // 查询店铺列表，将第一个作为默认值
      refetch();
    }
  }, []);
  var navigators = [{
    path: '/',
    isLogo: true,
    text: versionMap.get((user === null || user === void 0 ? void 0 : user.versionType) || 'normal'),
    icon: '/images/chitu_logo2.png',
    title: ''
  }, {
    path: '/',
    text: '首页',
    icon: '/images/menu_index.png',
    activeIcon: '/images/menu_index_active.png'
  }, {
    path: '/run',
    text: '数据化运营',
    icon: '/images/menu_run.png',
    activeIcon: '/images/menu_run_active.png'
  } // {
  //   path: '/twoone',
  //   text: '“21天”打造爆款',
  //   icon: '/images/menu_hot2.png',
  //   activeIcon: '/images/menu_hot.png',
  // },
  ];

  if (isInternal) {
    navigators.push({
      path: '/know',
      text: '知识库',
      icon: '/images/menu_know2.png',
      activeIcon: '/images/menu_know.png'
    });
  }

  var afterNavigators = [{
    path: '/plugin',
    text: '浏览器插件',
    icon: '/images/menu_plugin2.png',
    activeIcon: '/images/menu_plugin.png'
  }, {
    path: '/enterprise',
    text: '企业管理',
    icon: '/images/menu_company2.png',
    activeIcon: '/images/menu_company.png'
  }];
  navigators.push.apply(navigators, afterNavigators);

  if (isInternal && (user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.includes('超级管理员'))) {
    navigators.push({
      path: '/manage',
      text: '设置',
      icon: '/images/menu_setting.png',
      activeIcon: '/images/menu_setting_active.png'
    });
  }

  var rightMenus = [{
    key: 'logout',
    text: '退出登录'
  }];

  if (isNormal) {
    rightMenus.unshift({
      key: 'myOrder',
      text: '我的订单'
    });
  } else if (isInternal) {
    rightMenus.unshift({
      key: 'clientManage',
      text: '用户中心'
    }, {
      key: 'clientInvite',
      text: '客户邀请'
    }, {
      key: 'modifyPwd',
      text: '修改密码'
    });
  }

  return /*#__PURE__*/Object(jsx_runtime["jsx"])(jsx_runtime["Fragment"], {
    children: user ? /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container, {
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(components_common["i" /* Navigator */], {
        children: navigators.map(function (navigator) {
          return /*#__PURE__*/Object(jsx_runtime["jsx"])(components_common["i" /* Navigator */].Item, _objectSpread({}, navigator), navigator.text);
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(dropdown["a" /* default */], {
          visible: shopDropdownVisible,
          overlay: /*#__PURE__*/Object(jsx_runtime["jsx"])(components_common["m" /* ShopChangeMenu */], {
            onClose: setShopDropdownVisible
          }),
          trigger: ['click'],
          onVisibleChange: setShopDropdownVisible,
          children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(ShopChangeItem, {
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(common["c" /* Box */], {
              mRight: 4,
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(ShopName, {
                width: 173,
                children: currentShop === null || currentShop === void 0 ? void 0 : currentShop.shopName
              }), (currentShop === null || currentShop === void 0 ? void 0 : currentShop.resourceOwner) && /*#__PURE__*/Object(jsx_runtime["jsxs"])(ResourceOwner, {
                width: 173,
                children: ["\u8BDA\u4FE1\u901AID: ", currentShop === null || currentShop === void 0 ? void 0 : currentShop.resourceOwner]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(DownOutlined["a" /* default */], {})]
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(VLine, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(dropdown["a" /* default */], {
          overlay: /*#__PURE__*/Object(jsx_runtime["jsx"])(menu["a" /* default */], {
            onClick: function onClick(e) {
              switch (e.key) {
                case 'logout':
                  handleLogout();
                  break;

                case 'myOrder':
                  router.push('/usercenter/order/myorder');
                  break;

                case 'clientManage':
                  router.push('/usercenter/client/client-manage');
                  break;

                case 'clientInvite':
                  router.push('/usercenter/client/client-invite');
                  break;

                case 'modifyPwd':
                  modal["a" /* default */].info({
                    title: /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["p" /* Text */], {
                      color: "#333333",
                      isBold: false,
                      children: ["\u5185\u90E8\u7528\u6237\u4FEE\u6539\u5BC6\u7801\u8BF7\u53BB", /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
                        as: "a",
                        type: "link",
                        href: "http://yunying.kmwl1688.com/",
                        target: "_blank",
                        isBold: false,
                        children: "\u8FD0\u8425\u5E73\u53F0"
                      }), "\u4FEE\u6539"]
                    })
                  });
                  break;

                default:
                  break;
              }
            },
            children: rightMenus.map(function (item) {
              return /*#__PURE__*/Object(jsx_runtime["jsx"])(menu["a" /* default */].Item, {
                children: item.text
              }, item.key);
            })
          }),
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
            mRight: 16,
            isCursor: true,
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Nickname, {
              children: user.realName || user.userName
            })
          })
        })]
      })]
    }) : null
  });
}
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__("W9HT");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./src/model/home.ts
var home = __webpack_require__("5oTr");

// CONCATENATED MODULE: ./src/components/layout/SiteLayout.tsx





/*
 * @Author: yewei
 * @Date: 2021-01-18 10:34:31
 * @Last Modified by: yewei
 * @Last Modified time: 2022-01-17 23:05:31
 *
 * 主应用的布局
 * 包含顶部导航栏
 */










var Content = styled_components_browser_esm["d" /* default */].section.withConfig({
  displayName: "SiteLayout__Content",
  componentId: "sc-tlpkuv-0"
})(["padding-top:", ";height:100%;background:url('/images/main_bg.png') no-repeat;background-size:cover;display:flex;flex-direction:column;overflow-y:scroll;"], function (_ref) {
  var theme = _ref.theme,
      isShowHeader = _ref.isShowHeader;
  return isShowHeader ? theme.headerHeight : 0;
});
var SpinBox = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "SiteLayout__SpinBox",
  componentId: "sc-tlpkuv-1"
})(["width:100%;text-align:center;padding-top:80px;"]);
function SiteLayout(_ref2) {
  var children = _ref2.children,
      _ref2$isShowHeader = _ref2.isShowHeader,
      isShowHeader = _ref2$isShowHeader === void 0 ? true : _ref2$isShowHeader;
  var router = Object(next_router["useRouter"])();

  var _useRecoilState = Object(recoil["useRecoilState"])(model_user["e" /* userState */]),
      _useRecoilState2 = Object(slicedToArray["default"])(_useRecoilState, 1),
      user = _useRecoilState2[0];

  var _useRecoilState3 = Object(recoil["useRecoilState"])(model_user["b" /* currentShopState */]),
      _useRecoilState4 = Object(slicedToArray["default"])(_useRecoilState3, 1),
      currentShop = _useRecoilState4[0];

  var _useRecoilState5 = Object(recoil["useRecoilState"])(home["c" /* rightMenuScroll */]),
      _useRecoilState6 = Object(slicedToArray["default"])(_useRecoilState5, 2),
      rightMenuIsScroll = _useRecoilState6[0],
      setRightMenuIsScroll = _useRecoilState6[1];

  var _useRecoilState7 = Object(recoil["useRecoilState"])(home["b" /* productAttributeIsAble */]),
      _useRecoilState8 = Object(slicedToArray["default"])(_useRecoilState7, 1),
      attributeIsAble = _useRecoilState8[0];

  var _useRecoilState9 = Object(recoil["useRecoilState"])(home["a" /* marketIsAble */]),
      _useRecoilState10 = Object(slicedToArray["default"])(_useRecoilState9, 1),
      marketAnlysisIsAble = _useRecoilState10[0];

  var component = null;

  if (router.pathname === '/user/login') {
    // 登录页
    component = children;
  } else if (user) {
    // currentShop?.id && 店铺 id
    // 已经登录
    if (router.pathname.includes('/run') && !(currentShop === null || currentShop === void 0 ? void 0 : currentShop.id)) {
      component = /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
        justify: "center",
        align: "center",
        style: {
          height: '100vh',
          flexDirection: 'column'
        },
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mBottom: 20,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: "/images/404.png",
            width: 138,
            height: 96,
            unoptimized: true
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mBottom: 16,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
            fontSize: 16,
            color: "#333333",
            children: "\u6682\u65E0\u53EF\u64CD\u4F5C\u6027\u5E97\u94FA"
          })
        })]
      });
    } else {
      component = /*#__PURE__*/Object(jsx_runtime["jsx"])(Content, {
        isShowHeader: isShowHeader,
        children: children
      });
    }
  } else {
    component = /*#__PURE__*/Object(jsx_runtime["jsx"])(SpinBox, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(spin["a" /* default */], {})
    });
  } //市场分析 滚动时候不显示header


  var showMuen = router.pathname.includes('/run/market/market-analyse') && rightMenuIsScroll && marketAnlysisIsAble;
  var showMuen2 = router.pathname.includes('/run/market/product-attribute') && rightMenuIsScroll && attributeIsAble;
  Object(react["useEffect"])(function () {
    setRightMenuIsScroll(false);
  }, [router.pathname]);
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(jsx_runtime["Fragment"], {
    children: [router.pathname !== '/user/login' && isShowHeader && !showMuen && !showMuen2 && /*#__PURE__*/Object(jsx_runtime["jsx"])(Header, {}), component]
  });
}
// EXTERNAL MODULE: ./src/components/layout/MenuLayout.tsx + 1 modules
var MenuLayout = __webpack_require__("oCCe");

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__("0lfv");

// CONCATENATED MODULE: ./src/components/layout/PageLayout.tsx



/*
 * @Author: yewei
 * @Date: 2021-01-23 12:01:17
 * @Last Modified by: yewei
 * @Last Modified time: 2021-01-30 17:02:19
 *
 * 负责页面加载状态，接口错误显示，页脚的copyright
 */





var PageLayout_Container = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "PageLayout__Container",
  componentId: "sc-1og2zpr-0"
})(["flex:1;position:relative;display:flex;flex-direction:column;"]);
var PageContent = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "PageLayout__PageContent",
  componentId: "sc-1og2zpr-1"
})(["flex:1;"]);
var ErrorView = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "PageLayout__ErrorView",
  componentId: "sc-1og2zpr-2"
})(["display:flex;justify-content:center;align-items:center;margin:0 ", ";flex:1;"], Object(utils["v" /* r */])(20));
var ErrorContent = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "PageLayout__ErrorContent",
  componentId: "sc-1og2zpr-3"
})(["width:", ";height:", ";background:", ";background-size:cover;"], Object(utils["v" /* r */])(213), Object(utils["v" /* r */])(170), function (_ref) {
  var type = _ref.type;
  return type === 'error' ? "url('/images/data_error.png') no-repeat" : "url('/images/data_null.png') no-repeat";
});

var PageLayout_PageLayout = function PageLayout(_ref2) {
  var children = _ref2.children,
      _ref2$isShowCopy = _ref2.isShowCopy,
      isShowCopy = _ref2$isShowCopy === void 0 ? true : _ref2$isShowCopy,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? '' : _ref2$error,
      _ref2$noData = _ref2.noData,
      noData = _ref2$noData === void 0 ? false : _ref2$noData;
  var component = null;

  if (error) {
    component = /*#__PURE__*/Object(jsx_runtime["jsx"])(ErrorView, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(ErrorContent, {
        type: 'error'
      })
    });
  } else if (loading) {
    component = /*#__PURE__*/Object(jsx_runtime["jsx"])(PageContent, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(spin["a" /* default */], {
        spinning: loading,
        children: children
      })
    });
  } else if (noData) {
    component = /*#__PURE__*/Object(jsx_runtime["jsx"])(ErrorView, {
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(ErrorContent, {
        type: 'nodata'
      })
    });
  } else {
    component = /*#__PURE__*/Object(jsx_runtime["jsx"])(PageContent, {
      children: children
    });
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(PageLayout_Container, {
    children: [component, isShowCopy && /*#__PURE__*/Object(jsx_runtime["jsx"])(components_common["c" /* Copyright */], {})]
  });
};

/* harmony default export */ var layout_PageLayout = (PageLayout_PageLayout);
// EXTERNAL MODULE: ./src/hooks/index.ts
var src_hooks = __webpack_require__("eZYV");

// CONCATENATED MODULE: ./src/components/layout/CommonLayout.tsx










var CommonLayout_Container = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "CommonLayout__Container",
  componentId: "sc-hfk7tq-0"
})(["width:100vw;height:100%;display:flex;flex-direction:column;overflow-x:hidden !important;overflow-y:auto !important;margin-bottom:90px;", " background-size:cover;"], function (_ref) {
  var bg = _ref.bg;
  return Object(styled_components_browser_esm["c" /* css */])(["background:url(", ") no-repeat;"], bg);
});
var CommonLayout_Header = styled_components_browser_esm["d" /* default */].header.withConfig({
  displayName: "CommonLayout__Header",
  componentId: "sc-hfk7tq-1"
})(["margin-top:21px;margin-left:26px;", " @media (max-width:996px){margin-top:", ";margin-left:", ";}"], function (_ref2) {
  var type = _ref2.type;
  return type === 'report' && Object(styled_components_browser_esm["c" /* css */])(["margin-top:13px;margin-left:25px;"]);
}, Object(utils["u" /* px2rem750 */])(38), Object(utils["u" /* px2rem750 */])(52));
var Address = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "CommonLayout__Address",
  componentId: "sc-hfk7tq-2"
})(["font-size:12px;color:#617278;text-align:center;", ""], function (_ref3) {
  var addColor = _ref3.addColor;
  return Object(styled_components_browser_esm["c" /* css */])(["color:", ";"], addColor);
});
var Scroll = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "CommonLayout__Scroll",
  componentId: "sc-hfk7tq-3"
})(["flex:1;display:flex;flex-direction:column;"]);
var StartImg = styled_components_browser_esm["d" /* default */].img.withConfig({
  displayName: "CommonLayout__StartImg",
  componentId: "sc-hfk7tq-4"
})(["width:120px;height:42px;position:relative;"]);

var CommonLayout_CommonLayout = function CommonLayout(_ref4) {
  var children = _ref4.children,
      type = _ref4.type,
      setFixedCatalogue = _ref4.setFixedCatalogue,
      _ref4$hasCopyRight = _ref4.hasCopyRight,
      hasCopyRight = _ref4$hasCopyRight === void 0 ? true : _ref4$hasCopyRight;

  var _useSizeAccordingMedi = Object(src_hooks["e" /* useSizeAccordingMedia */])(),
      returnAcrrodingMedia = _useSizeAccordingMedi.returnAcrrodingMedia;

  var bg = '/images/main_bg.png'; //

  var logoComp = /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
      width: returnAcrrodingMedia(268, 268),
      height: returnAcrrodingMedia(36, 36),
      isRelative: true,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
        layout: "fill",
        src: "/images/common_layout_logo.png",
        unoptimized: true,
        priority: true
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
      isRelative: true,
      mLeft: returnAcrrodingMedia(38, 38),
      width: returnAcrrodingMedia(66, 66),
      height: returnAcrrodingMedia(33, 33),
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
        src: "/images/chitu_logo.png",
        layout: "fill",
        unoptimized: true,
        priority: true
      })
    })]
  });

  var addColor = '#666666';

  if (type === 'invite') {
    bg = '/images/invite_bg.png';
    logoComp = /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
        width: returnAcrrodingMedia(268, 268),
        height: returnAcrrodingMedia(36, 30),
        isRelative: true,
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
          layout: "fill",
          src: "/images/invite_logo.png",
          priority: true,
          unoptimized: true
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
        isRelative: true,
        mLeft: returnAcrrodingMedia(38, 38),
        width: returnAcrrodingMedia(66, 66),
        height: returnAcrrodingMedia(33, 33),
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
          src: "/images/invite_chitu.png",
          layout: "fill",
          unoptimized: true,
          priority: true
        })
      })]
    });
    addColor = '#ffffff';
  } else if (type === 'report') {
    bg = '/images/report_bg.jpg';
    var meun = [{
      name: '公司官网',
      path: 'http://www.tmz1688.com'
    }, {
      name: '快门代运营',
      path: 'http://www.tmz1688.com/thirdpartnar'
    }, {
      name: ' 铁木真商学院',
      path: 'http://www.tmz1688.com/school'
    }, {
      name: ' 关于我们',
      path: 'http://www.tmz1688.com/about/introduce'
    }];
    logoComp = /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
      align: "center",
      width: "100%",
      justify: "space-between",
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mRight: 35,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            width: 215,
            height: 59,
            src: "/images/white_logo.png",
            priority: true,
            unoptimized: true
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["m" /* SeparationLine */], {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mLeft: 35,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(StartImg, {
            src: "/images/star_logo.png"
          })
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
        align: "center",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(common["p" /* Text */], {
          color: "#FFFFFF",
          fontSize: 14,
          isBold: true,
          marginRight: 39,
          children: ["\u54A8\u8BE2\u70ED\u7EBF:", /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
            color: "#DD9A1A",
            fontSize: 14,
            isBold: true,
            marginLeft: 5,
            children: "400-801-7720"
          })]
        }), meun.map(function (ite) {
          return /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
            isCursor: true,
            color: "#FFFFFF",
            fontSize: 14,
            isBold: true,
            marginRight: 39,
            onClick: function onClick() {
              window.open(ite.path);
            },
            children: ite.name
          });
        })]
      })]
    });
    addColor = '#DAE3FF';
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(CommonLayout_Container, {
    bg: bg,
    onScrollCapture: function onScrollCapture(e) {
      // 报告目录跟随 e.target.scrollTop > 0 发生滚动触发
      if (e.target.scrollTop > 353) {
        setFixedCatalogue(true);
      } else {
        setFixedCatalogue(false);
      }
    },
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(CommonLayout_Header, {
      type: type,
      children: logoComp
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(Scroll, {
      children: [children, hasCopyRight && /*#__PURE__*/Object(jsx_runtime["jsxs"])(jsx_runtime["Fragment"], {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mBottom: 11,
          mTop: 30,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Address, {
            addColor: addColor,
            children: "\u5730\u5740\uFF1A\u6D59\u6C5F\u676D\u5DDE\u5E02\u6EE8\u6C5F\u533A\u5EFA\u4E1A\u8DEF511\u53F7\u534E\u521B\u5927\u53A6410\u5BA4"
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
          mBottom: 92,
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(components_common["c" /* Copyright */], {
            margin: '0',
            color: addColor
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var layout_CommonLayout = (CommonLayout_CommonLayout);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./src/components/common/Portal.tsx
var Portal = __webpack_require__("TerX");

// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 3 modules
var message = __webpack_require__("tsqr");

// EXTERNAL MODULE: ./node_modules/braft-utils/dist/index.js
var dist = __webpack_require__("Psm9");

// CONCATENATED MODULE: ./src/components/run/feedback/Feedback.tsx














var DynamicFeedbackForm = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(26), __webpack_require__.e(27), __webpack_require__.e(32), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "tqXU"));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("tqXU")];
    },
    modules: ['@/components/run/feedback/DynamicFeedbackForm']
  }
});
var FeedbackText = Object(styled_components_browser_esm["d" /* default */])(common["p" /* Text */]).withConfig({
  displayName: "Feedback__FeedbackText",
  componentId: "sc-uxmj4c-0"
})([""]);
var Feedback_Container = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Feedback__Container",
  componentId: "sc-uxmj4c-1"
})(["width:40px;height:68px;position:fixed;bottom:75px;right:0;background-color:#fefeff;box-shadow:0px 2px 13px 0px rgba(0,10,71,0.06);display:flex;flex-direction:column;align-items:center;cursor:pointer;z-index:9999;background:url('/images/feedback_icon.png') no-repeat #fefeff;background-size:20px 20px;background-position:10px 12px;padding-top:42px;&:hover{background-image:url('/images/feedback_icon_hover.png');}&:hover ", "{color:#006cff;transition:all 0.3s ease-in-out;}"], FeedbackText);
var Modal = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Feedback__Modal",
  componentId: "sc-uxmj4c-2"
})(["width:584px;height:465px;background:#fefeff;box-shadow:0px 40px 45px 0px rgba(18,22,41,0.2);border-radius:6px;position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;transition:all 0.3s ease-in-out;transform:translate(600px,200px) scale(0);transform-origin:right bottom;opacity:0;z-index:9999;", ""], function (_ref) {
  var visible = _ref.visible;
  return visible && Object(styled_components_browser_esm["c" /* css */])(["transform:translate(0,0) scale(1);opacity:1;"]);
});
var ModalHeader = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Feedback__ModalHeader",
  componentId: "sc-uxmj4c-3"
})(["height:56px;background:#006cff;border-radius:6px 6px 0px 0px;padding:8px 20px 8px 15px;display:flex;justify-content:space-between;align-items:center;"]);
var Footer = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Feedback__Footer",
  componentId: "sc-uxmj4c-4"
})(["height:55px;display:flex;align-items:center;"]);
var InsertPic = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Feedback__InsertPic",
  componentId: "sc-uxmj4c-5"
})(["width:130px;height:100%;margin-right:2px;background-color:#ebeff4;display:flex;align-items:center;justify-content:center;cursor:pointer;border-bottom-left-radius:6px;position:relative;"]);
var Submit = Object(styled_components_browser_esm["d" /* default */])(common["p" /* Text */]).withConfig({
  displayName: "Feedback__Submit",
  componentId: "sc-uxmj4c-6"
})(["height:100%;flex:1;background-color:#ebeff4;display:flex;align-items:center;justify-content:center;cursor:pointer;border-bottom-right-radius:6px;user-select:none;", ""], function (_ref2) {
  var enabled = _ref2.enabled;
  return Object(styled_components_browser_esm["c" /* css */])(["color:", ";cursor:", ";"], enabled ? '#485160' : '#ABAFB3', enabled ? 'pointer' : 'not-allowed');
});
var Upload = styled_components_browser_esm["d" /* default */].input.withConfig({
  displayName: "Feedback__Upload",
  componentId: "sc-uxmj4c-7"
})(["position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;cursor:pointer;"]);
var noNeedPaths = ['/user/login', '/invite', '/register-policy', '/404', '/snapshoot'];

var Feedback_Feedback = function Feedback() {
  var _useState = Object(react["useState"])(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useState2 = Object(react["useState"])(),
      editorState = _useState2[0],
      setEditorState = _useState2[1];

  var router = Object(next_router["useRouter"])();
  var isHide = noNeedPaths.includes(router.pathname) || router.pathname.includes('/lecture');

  var _useMutation = Object(es["useMutation"])(api["Rd" /* submitFeedback */], {
    onSuccess: function onSuccess(res) {
      if (res.code === 10000) {
        message["b" /* default */].success(res.message);
        setVisible(false);
      }
    }
  }),
      submit = _useMutation.mutate;

  Object(react["useEffect"])(function () {
    function hide() {
      setVisible(false);
    }

    document.addEventListener('click', hide);
    return function () {
      document.removeEventListener('click', hide);
    };
  }, []);
  var hasFeedback = (editorState === null || editorState === void 0 ? void 0 : editorState.toHTML()) !== '<p></p>';

  var handleChange = function handleChange(e) {
    Object(utils["x" /* selfUploadMedia */])(e.target.files, function (img) {
      var state = dist["ContentUtils"].insertMedias(editorState, [{
        type: 'IMAGE',
        url: img
      }]);
      setEditorState(state);
    });
    e.target.value = '';
  };

  return !isHide ? /*#__PURE__*/Object(jsx_runtime["jsxs"])(Feedback_Container, {
    onClick: function onClick(e) {
      e.stopPropagation();
      setVisible(true);
    },
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(FeedbackText, {
      fontSize: 12,
      color: "#333333",
      isBold: false,
      children: "\u53CD\u9988"
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Portal["a" /* default */], {
      children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Modal, {
        visible: visible,
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(ModalHeader, {
          children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(common["k" /* Row */], {
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
              mRight: 20,
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
                src: "/images/feedback_machine.png",
                unoptimized: true,
                width: 40,
                height: 40
              })
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
              color: "#FEFEFF",
              children: "\u53CD\u9988"
            })]
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
            isCursor: true,
            onClick: function onClick(e) {
              e.stopPropagation();
              setVisible(false);
            },
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
              src: "/images/feedback_close.png",
              unoptimized: true,
              width: 28,
              height: 28
            })
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(DynamicFeedbackForm, {
          editorState: editorState,
          setEditorState: setEditorState,
          visible: visible
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(Footer, {
          children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(InsertPic, {
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(common["c" /* Box */], {
              mRight: 12,
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
                src: "/images/feedback_insert.png",
                unoptimized: true,
                width: 16,
                height: 15
              })
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(common["p" /* Text */], {
              color: "#485160",
              isBold: false,
              children: "\u63D2\u5165\u56FE\u7247"
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Upload, {
              type: "file",
              name: "file",
              accept: "image/*",
              onChange: handleChange
            })]
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Submit, {
            enabled: hasFeedback,
            type: "link",
            onClick: function onClick() {
              if (hasFeedback) {
                submit({
                  content: editorState === null || editorState === void 0 ? void 0 : editorState.toHTML()
                });
              }
            },
            children: "\u63D0\u4EA4"
          })]
        })]
      })
    })]
  }) : null;
};

/* harmony default export */ var feedback_Feedback = (Feedback_Feedback);
// CONCATENATED MODULE: ./src/components/run/snapshoot/Snapshoot.tsx














var Snapshoot_DynamicFeedbackForm = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(26), __webpack_require__.e(27), __webpack_require__.e(32), __webpack_require__.e(40)]).then(__webpack_require__.bind(null, "tqXU"));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("tqXU")];
    },
    modules: ['@/components/run/feedback/DynamicFeedbackForm']
  }
});
var Snapshoot_FeedbackText = Object(styled_components_browser_esm["d" /* default */])(common["p" /* Text */]).withConfig({
  displayName: "Snapshoot__FeedbackText",
  componentId: "sc-2knpsy-0"
})([""]);
var Snapshoot_Container = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Snapshoot__Container",
  componentId: "sc-2knpsy-1"
})(["width:40px;height:68px;position:fixed;bottom:144px;right:0;background-color:#fefeff;box-shadow:0px 2px 13px 0px rgba(0,10,71,0.06);display:flex;flex-direction:column;align-items:center;cursor:pointer;z-index:9999;background:url('/images/snapshoot.png') no-repeat #fefeff;background-size:20px 20px;background-position:10px 12px;padding-top:42px;&:hover{background-image:url('/images/snapshoot_hover.png');}&:hover ", "{color:#006cff;transition:all 0.3s ease-in-out;}"], Snapshoot_FeedbackText);
var Snapshoot_Modal = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Snapshoot__Modal",
  componentId: "sc-2knpsy-2"
})(["width:584px;height:465px;background:#fefeff;box-shadow:0px 40px 45px 0px rgba(18,22,41,0.2);border-radius:6px;position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;transition:all 0.3s ease-in-out;transform:translate(600px,200px) scale(0);transform-origin:right bottom;opacity:0;z-index:9999;", ""], function (_ref) {
  var visible = _ref.visible;
  return visible && Object(styled_components_browser_esm["c" /* css */])(["transform:translate(0,0) scale(1);opacity:1;"]);
});
var Snapshoot_ModalHeader = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Snapshoot__ModalHeader",
  componentId: "sc-2knpsy-3"
})(["height:56px;background:#006cff;border-radius:6px 6px 0px 0px;padding:8px 20px 8px 15px;display:flex;justify-content:space-between;align-items:center;"]);
var Snapshoot_Footer = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Snapshoot__Footer",
  componentId: "sc-2knpsy-4"
})(["height:55px;display:flex;align-items:center;"]);
var Snapshoot_InsertPic = styled_components_browser_esm["d" /* default */].div.withConfig({
  displayName: "Snapshoot__InsertPic",
  componentId: "sc-2knpsy-5"
})(["width:130px;height:100%;margin-right:2px;background-color:#ebeff4;display:flex;align-items:center;justify-content:center;cursor:pointer;border-bottom-left-radius:6px;position:relative;"]);
var Snapshoot_Submit = Object(styled_components_browser_esm["d" /* default */])(common["p" /* Text */]).withConfig({
  displayName: "Snapshoot__Submit",
  componentId: "sc-2knpsy-6"
})(["height:100%;flex:1;background-color:#ebeff4;display:flex;align-items:center;justify-content:center;cursor:pointer;border-bottom-right-radius:6px;user-select:none;", ""], function (_ref2) {
  var enabled = _ref2.enabled;
  return Object(styled_components_browser_esm["c" /* css */])(["color:", ";cursor:", ";"], enabled ? '#485160' : '#ABAFB3', enabled ? 'pointer' : 'not-allowed');
});
var Snapshoot_Upload = styled_components_browser_esm["d" /* default */].input.withConfig({
  displayName: "Snapshoot__Upload",
  componentId: "sc-2knpsy-7"
})(["position:absolute;width:100%;height:100%;top:0;left:0;opacity:0;cursor:pointer;"]);
var Exist = ['/run/market/market-analyse', '/run/market/product-attribute'];

var Snapshoot_Snapshoot = function Snapshoot() {
  var _useState = Object(react["useState"])(false),
      visible = _useState[0],
      setVisible = _useState[1];

  var _useState2 = Object(react["useState"])(),
      editorState = _useState2[0],
      setEditorState = _useState2[1];

  var router = Object(next_router["useRouter"])();

  var _useRecoilState = Object(recoil["useRecoilState"])(model_user["e" /* userState */]),
      _useRecoilState2 = Object(slicedToArray["default"])(_useRecoilState, 1),
      user = _useRecoilState2[0];

  var isExist = Exist.includes(router.pathname) && (user === null || user === void 0 ? void 0 : user.versionType) === 'internal';

  var _useMutation = Object(es["useMutation"])(api["Rd" /* submitFeedback */], {
    onSuccess: function onSuccess(res) {
      if (res.code === 10000) {
        message["b" /* default */].success(res.message);
        setVisible(false);
      }
    }
  }),
      submit = _useMutation.mutate;

  Object(react["useEffect"])(function () {
    function hide() {
      setVisible(false);
    }

    document.addEventListener('click', hide);
    return function () {
      document.removeEventListener('click', hide);
    };
  }, []);
  var hasFeedback = (editorState === null || editorState === void 0 ? void 0 : editorState.toHTML()) !== '<p></p>';

  var handleChange = function handleChange(e) {
    Object(utils["x" /* selfUploadMedia */])(e.target.files, function (img) {
      var state = dist["ContentUtils"].insertMedias(editorState, [{
        type: 'IMAGE',
        url: img
      }]);
      setEditorState(state);
    });
    e.target.value = '';
  };

  return isExist ? /*#__PURE__*/Object(jsx_runtime["jsx"])(Snapshoot_Container, {
    onClick: function onClick(e) {
      e.stopPropagation();
      router.push('/snapshoot');
    },
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Snapshoot_FeedbackText, {
      fontSize: 12,
      color: "#333333",
      isBold: false,
      children: "\u5FEB\u7167\u5939"
    })
  }) : null;
};

/* harmony default export */ var snapshoot_Snapshoot = (Snapshoot_Snapshoot);
// CONCATENATED MODULE: ./src/components/layout/AppLayout.tsx




/*
 * @Author: yewei
 * @Date: 2021-08-06 13:59:15
 * @Last Modified by: yewei
 * @Last Modified time: 2022-02-01 20:25:34
 *
 * 包含了用户反馈功能
 */




var AppLayout_AppLayout = function AppLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(jsx_runtime["Fragment"], {
    children: [children, /*#__PURE__*/Object(jsx_runtime["jsx"])(feedback_Feedback, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(snapshoot_Snapshoot, {})]
  });
};

/* harmony default export */ var layout_AppLayout = (AppLayout_AppLayout);
// CONCATENATED MODULE: ./src/components/layout/index.ts







/***/ }),

/***/ "TerX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("i8i4");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);




var Portal = function Portal(_ref) {
  var children = _ref.children;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setMounted(true);
    return function () {
      return setMounted(false);
    };
  }, []);

  if (mounted) {
    var container = document.querySelector('#self-modal');
    return container ? /*#__PURE__*/Object(react_dom__WEBPACK_IMPORTED_MODULE_1__["createPortal"])(children, container) : null;
  }

  return null;
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ })

}]);